import React from 'react';
import {Stack} from '@mui/material';
import ImprovementsTaskCard from './ImprovementsTaskCard';

export default function ImprovementsTaskList({
                                                 tasks,
                                                 editorView,
                                                 canNavigateTask,
                                                 onTaskNavigate,
                                                 onTaskAccept,
                                                 onTaskReject,
                                                 onTaskSelectAnotherEntity
                                             }) {
    return (
        <Stack spacing={1} p={1.5}
               bgcolor={'grey.100'}
               flex={1}
        >
            {tasks.map((task) => (
                <ImprovementsTaskCard
                    key={task.id}
                    task={task}
                    editorView={editorView}
                    canNavigate={canNavigateTask?.(task)}
                    onNavigate={onTaskNavigate}
                    onAccept={onTaskAccept}
                    onReject={onTaskReject}
                    onSelectAnotherEntity={onTaskSelectAnotherEntity}
                />
            ))}
        </Stack>
    );
}

